"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubAppProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const SubAppProviders = ({ children, history }) => ((0, jsx_runtime_1.jsx)(react_router_dom_1.Router, { history: history, children: children }));
exports.SubAppProviders = SubAppProviders;
//# sourceMappingURL=subapp.providers.js.map